import React from 'react'
import { } from '@ant-design/icons';
import style from "./index.less"



class pageFive extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }

    }

    // 发需求跳转
    toSendDemand() {
        // this.props.history.push("/register");
    }

    // 接任务跳转
    toReceiveTask() {
        // this.props.history.push("/register");
    }


    render() {
        return (
            <div className={style.pageFive_container}>
                {/* 上 */}
                <div className={style.fiveTop}>
                    {/* 上——左 */}
                    <div className={style.fiveLeft}>
                        <div className={style.fontOne}>
                            <div className={style.sthz}>
                                协同中心
                            </div>
                            <div className={style.picOne}>
                            </div>
                        </div>
                        <div className={style.fontTwo}>
                            <p>任务分发、全员助力、协同提效</p>
                        </div>
                        <div className={style.fontThree}>
                            <img className={style.point} src={require('assets/images/home/背景点点-.png')} alt="" />
                        </div>
                        {/* <div className={style.fontFour}>
                            <div className={style.SendDemand} onClick={this.toSendDemand}>
                                <Button className={style.btnSendDemand}>我要发需求</Button>
                            </div>
                            <div className={style.ReceiveTask} onClick={this.toReceiveTask}>
                                <Button className={style.btnReceiveTask}>我要接任务</Button>
                            </div>
                        </div> */}
                    </div>

                    {/* 上——右 */}
                    <div className={style.fiveRight}>
                        {/* 文字 */}
                        <div className={style.Publisher}>
                            <div className={style.PublisherS}>
                                {/* REQUIREMENTS PUBLISHER */}
                            </div>
                            <div className={style.PublisherSS}>
                                <span className={style.PublisherSSOne}>我是</span>
                                <span className={style.PublisherSSTwo}>需求发布者</span>
                            </div>
                            <div className={style.PublisherSSS}>
                                <p className={style.PublisherSSSOne}>作为需求方，你可以通过Howso@ALGO</p>
                                <p className={style.PublisherSSSTwo}>平台发布需求，并实时监控进度,验收结果</p>
                            </div>

                        </div>
                        {/* 方框图标1 */}
                        <div className={style.labelingTasks}>
                            <div className={style.pic}>
                                <img src={require('assets/images/page5/biaozhu.png')}></img>
                            </div>
                            <div className={style.fontOne}>标注任务</div>
                            <div className={style.fontTwo}>多人协同给图片打标注</div>
                        </div>

                        {/* 方框图标2 */}
                        <div className={style.collectionTasks}>
                            <div className={style.pic}>
                                <img src={require('assets/images/page5/shouji.png')}></img>
                            </div>
                            <div className={style.fontOne}>收集任务</div>
                            <div className={style.fontTwo}>各类目标主题图片收集</div>
                        </div>



                    </div>
                </div>

                {/* 下 */}
                <div className={style.fiveBottom}>
                    {/* 左_文字 */}
                    <div className={style.Participant}>
                        <div className={style.ParticipantS}>
                            {/* TASK   PARTICIPANTS */}
                        </div>
                        <div className={style.ParticipantSS}>
                            <span className={style.ParticipantSSOne}>我是</span>
                            <span className={style.ParticipantSSTwo}>任务参与者</span>
                        </div>
                        <div className={style.ParticipantSSS}>
                            <p className={style.ParticipantSSSOne}>通过Howso@ALGO平台接任务，并完成
                            </p>
                            <p className={style.ParticipantSSSTwo}>后可以获得积分奖励哦</p>
                        </div>
                    </div>
                    {/* 右_流程 */}
                    <div className={style.process}>
                        {/* 步骤一 */}
                        <div className={style.processOne}>
                            <div className={style.processNum}>1</div>
                            <div className={style.processImg}>
                                <img src={require('assets/images/page5/jie.png')}></img>
                            </div>
                            <div className={style.processName}>接任务</div>
                        </div>

                        {/* 箭头1 */}
                        <div className={style.arrowOne}>
                            <img src={require('assets/images/page5/arrow.png')}></img>
                        </div>

                        {/* 步骤二 */}
                        <div className={style.processTwo}>
                            <div className={style.processNum}>2</div>
                            <div className={style.processImg}>
                                <img src={require('assets/images/page5/zhixing.png')}></img>
                            </div>
                            <div className={style.processName}>执行任务</div>
                        </div>

                        {/* 箭头2 */}
                        <div className={style.arrowTwo}>
                            <img src={require('assets/images/page5/arrow.png')}></img>
                        </div>

                        {/* 步骤三 */}
                        <div className={style.processThree}>
                            <div className={style.processNum}>3</div>
                            <div className={style.processImg}>
                                <img src={require('assets/images/page5/jiesuan.png')}></img>
                            </div>
                            <div className={style.processName}>结算积分</div>
                        </div>
                    </div>

                </div>

                {/* 背景1 */}
                <div className={style.bgOne}>
                    <img src={require('assets/images/page5/bgImgOne.png')} alt="" />
                </div>

                {/* 背景2 */}
                <div className={style.bgTwo}>
                    <img src={require('assets/images/page5/bgImgTwo.png')} alt="" />
                </div>


            </div>
        )
    }

}

export default pageFive